import { createContext, useContext, useState } from "react";
import defaultFlowConfig from "../config/flowConfig.json";
import defaultQuestions from "../config/questions.json";
import { EmailUrl, FirebasePublicUrl } from "../constants";

export const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [configData, setConfigData] = useState(defaultFlowConfig);
  const [logo, setLogo] = useState("logo.png");
  const userQuestions = defaultQuestions;
  const [selectedAnswers, setSelectedAnswers] = useState({
    "question-1": "",
    "question-2": "",
  });
  const [userEmail, setUserEmail] = useState("");
  const [isEmailSent, setIsEmailSent] = useState(false);

  const resetUserData = () => {
    setUserEmail("");
    setIsEmailSent(false);
    setSelectedAnswers({ "question-1": "", "question-2": "" });
  };

  const updatePartnerName = async (newName) => {
    setConfigData((prevData) => ({ ...prevData, partnerName: newName }));
    setLogo(
      `${FirebasePublicUrl}${newName}%2Ffrontend%2Fpublic%2Flogo.png?alt=media`,
    );
  };

  const sendEmail = (
    language,
    apiToken,
    aiResults,
    recommendations,
    trackState = false,
  ) => {
    if (userEmail === "") return;

    try {
      fetch(`${EmailUrl}?lng=${language}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        body: JSON.stringify({
          email: userEmail,
          results: aiResults,
          recommendations: recommendations,
        }),
      });
      if (trackState) {
        setIsEmailSent(true);
      }
    } catch (error) {
      console.error("Failed to send email!");
    }
  };

  return (
    <ConfigContext.Provider
      value={{
        logo,
        configData,
        userQuestions,
        userEmail,
        selectedAnswers,
        isEmailSent,
        setSelectedAnswers,
        setUserEmail,
        sendEmail,
        resetUserData,
        updatePartnerName,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
